import React from 'react';
import { Link, Navigate, NavLink } from 'react-router-dom';
import { Server } from '../../server/server';
import AlertModal from '../modals/AlertModal';
import ChangeEmailModal from '../modals/ChangeEmailModal';
import MessageModal from '../modals/MessageModal';
import './AccountPage.css';

interface ProfilePageState {
  newPassword: string;
  currentPassword: string;
  name: string;
  slug: string;
  message: string;
  alert: string;
  loading: boolean;
  openChangeEmail: boolean;
}

class ProfilePage extends React.Component<{}, ProfilePageState> {
  constructor(props:{}) {
    super(props);

    this.state = {
      message: '',
      alert: '',
      newPassword: '',
      currentPassword: '',
      name: Server.user.getName(),
      slug: Server.user.getSlug(),
      loading: false,
      openChangeEmail: false
    };

    this.onNewPasswordChange = this.onNewPasswordChange.bind(this);
    this.onCurrentPasswordChange = this.onCurrentPasswordChange.bind(this);
    this.onSavePassword = this.onSavePassword.bind(this);
    this.onClearCaches = this.onClearCaches.bind(this);
  }

  onNewPasswordChange(e: React.FormEvent<HTMLInputElement>): void {
    this.setState({newPassword: e.currentTarget.value});
  };

  onCurrentPasswordChange(e: React.FormEvent<HTMLInputElement>): void {
    this.setState({currentPassword: e.currentTarget.value});
  };

  async onSavePassword() {
    if(this.state.newPassword.length == 0 || this.state.currentPassword.length == 0) {
      this.setState({alert: 'Password cannot be blank.'});
      return;
    }

    this.setState({message: 'Changing password...'});

    let response = await Server.account.changePassword(this.state.currentPassword, this.state.newPassword);

    if(response.success)
      this.setState({message: '', alert: 'Password successfully changed!', newPassword: '', currentPassword: ''})
    else
      this.setState({message: '', alert: response.message});
  }

  onClearCaches() {
    this.setState({message: 'Clearing caches...'});
    setTimeout(() => {
      window.localStorage.removeItem('AssetsDatabaseVersion');
      window.localStorage.removeItem('AssetsDatabase');
      window.localStorage.removeItem('ShopDatabaseVersion');
      window.localStorage.removeItem('ShopDatabase');
      window.location.reload();
    }, 1000);
  }

  async onResetAccount() {
    this.setState({message: 'Resetting account...'});
    await Server.user.reset();
    this.setState({message: '', alert: 'Account reset.'});
  }

  async onDeleteAccount() {
    // ask are you sure?
    this.setState({message: 'Deleting account...'});
    let response = await Server.account.deleteUser();
    if(response.success) 
      this.setState({message: '', alert: 'Account deleted.'});
    else
      this.setState({message: response.message});
  }

  render() {
    if(!Server.account.isLoggedIn())
      return <Navigate to="/" replace />;

    return (
      <div>
        <div className="account-page">
          <div className="account-section">
            <div>Your email address is <span style={{color: 'white'}}>{Server.account.getEmail()}</span></div>
            <div>
              <button onClick={()=>this.setState({openChangeEmail: true})}>Change Email</button>
            </div>
          </div>
          
          <div className="account-section">
            <div>
              Current Password<br />
              <input style={{width: '250px', marginTop: '5px'}} type="password" value={this.state.currentPassword} onChange={this.onCurrentPasswordChange}></input>
            </div>
            <div>
              New Password<br />
              <input style={{width: '250px', marginTop: '5px'}} type="password" value={this.state.newPassword} onChange={this.onNewPasswordChange}></input>
            </div>
            <div>
              <button onClick={this.onSavePassword} disabled={this.state.loading}>Change Password</button>
            </div>
          </div>

          <div className="account-section">
            <div>Would you like to clear data caches and reload?</div>
            <div>
              <button onClick={this.onClearCaches} disabled={this.state.loading}>Clear Data Caches</button>
            </div>
          </div>
        </div>

        <MessageModal message={this.state.message}/>
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})}/>
        <ChangeEmailModal open={this.state.openChangeEmail} onClose={()=>this.setState({openChangeEmail: false})}/>
      </div>
    );
  }
}

export default ProfilePage;
